export default __webpack_public_path__ + "static/fccid-ef886583623ed8b75622e4074bc222a8.png";